export default "__VITE_ASSET__DQgu94bP__"